import { http } from 'utils/http';
import type { SignalingTokenResponse } from 'services/signaling';
import { getSignalingSocket } from 'services/signaling';
import { DetailedPollResultsPayload } from 'features/polls/types';

export const requestDetailedPollResultsService = async (
  id: string
): Promise<DetailedPollResultsPayload> =>
  getSignalingSocket().sendAsync<DetailedPollResultsPayload>({
    event: 'requestDetailedPollResults',
    data: {
      id,
    },
  });

export const exportPollResultsService = async (roomId: string) => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestDownloadToken',
    data: {
      type: 'polls',
    },
  });

  return http.get<Blob>(`/room-api/${roomId}/polls/export?format=txt/json`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const exportSinglePollService = async (roomId: string, pollId: string) => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestDownloadToken',
    data: {
      type: 'polls',
    },
  });

  return http.get<Blob>(`/room-api/${roomId}/polls/${pollId}/export?format=txt/json`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const downloadPollTemplateService = async (roomId: string) => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestDownloadToken',
    data: {
      type: 'poll-template',
    },
  });

  return http.get<Blob>(`/room-api/${roomId}/polls/template`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  });
};

export const importPollCsvService = async (roomId: string, file: File) => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestUploadToken',
    data: {
      type: 'polls',
    },
  });

  const formData = new FormData();
  formData.append('file', file);

  return http.post(`/room-api/${roomId}/polls/import`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const importPollTemplateCsvService = async (roomId: string, file: File) => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestUploadToken',
    data: {
      type: 'polls',
    },
  });

  const formData = new FormData();
  formData.append('file', file);

  return http.post(`/room-api/${roomId}/poll-templates/import`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};
